// tslint:disable:max-line-length

import React from 'react';

export const ActionRenew = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M7.8,1.9C4.8,2.1,2,4.5,2,8H0l3,3.1L6,8H4c0-3.6,4.3-5.5,6.8-2.9l1.4-1.4c-0.9-0.9-2-1.5-3.2-1.7C8.7,1.9,8.2,1.9,7.8,1.9z M13,4.9L10,8h2c0,3.6-4.3,5.5-6.8,2.9l-1.4,1.5C7.4,16.2,14,13.3,14,8h2L13,4.9L13,4.9z" />
    </svg>
  );
};
